import type { IconData } from '@stacksjs/iconify-core'

export const dicesF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M11 0a3 3 0 0 1 3 3v3h3a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3v-3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3zm-1 15a1 1 0 1 0 0 2a1 1 0 0 0 0-2m6 0a1 1 0 1 0 0 2a1 1 0 0 0 0-2m-3-3a1 1 0 1 0 0 2a1 1 0 0 0 0-2m-3-3a1 1 0 1 0 0 2a1 1 0 0 0 0-2m6 0a1 1 0 1 0 0 2a1 1 0 0 0 0-2M4.513 8.993a1 1 0 1 0 0 2a1 1 0 0 0 0-2m0-3a1 1 0 1 0 0 2a1 1 0 0 0 0-2m0-3a1 1 0 1 0 0 2a1 1 0 0 0 0-2m5 0a1 1 0 1 0 0 2a1 1 0 0 0 0-2\"/>",
  "width": 20,
  "height": 20,
  "viewBox": "0 0 20 20"
}

export default dicesF
